import { PropsWithChildren, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

import { SectionHeader } from "~/common/components";

interface PreviewSectionLayoutProps extends PropsWithChildren {
  title: string | ReactNode;
  className?: string;
  actions?: ReactNode;
}

export const PreviewSectionLayout = ({
  title,
  children,
  actions,
  className,
}: PreviewSectionLayoutProps) => (
  <div className="rounded-md border border-neutral-80">
    <div className="flex items-center justify-between rounded-t-md border-b border-neutral-80 bg-neutral-20 p-3">
      <SectionHeader>{title}</SectionHeader>
      {actions}
    </div>
    <div
      className={twMerge("flex flex-col gap-3 overflow-x-auto p-4", className)}
    >
      {children}
    </div>
  </div>
);
